import { Fragment } from "react";
import clsx from "clsx";
import { Avatar, Dropdown, List } from "antd";
import "./index.style.less";
import { useThemeContext } from "../../../../utility/AppContextProvider/ThemeContextProvider";
import IntlMessages from "../../../../utility/IntlMessages";
import { useDispatch, useSelector } from "react-redux";
import { setVisibleLogout } from "src/domain/app/redux/auth/auth-slice";
import { useNavigate } from "react-router-dom";
import { getMyProfile } from "src/domain/app/redux/auth/auth-selectors";
import { UserTypeArray } from "../../../../../shared/constants/AppConst";

const getInitials = (firstName?: string, lastName?: string) => {
  const f = firstName?.trim()?.[0] ?? "";
  const l = lastName?.trim()?.[0] ?? "";
  return (f + l).toUpperCase() || "?";
};

const UserInfo = () => {
  const { themeMode }: any = useThemeContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myProfile = useSelector(getMyProfile);
  const userRole = UserTypeArray.find(
    (item) => item.value === myProfile?.userType,
  );

  const initials = getInitials(myProfile?.firstName, myProfile?.lastName);

  const menu = (
    <List className="dropdown-list">
      <List.Item onClick={() => navigate("/my-profile")}>
        <List.Item.Meta title={<IntlMessages id="common.myProfile" />} />
      </List.Item>
      <List.Item className="dropdown-list-danger" onClick={() => dispatch(setVisibleLogout(true))}>
        <List.Item.Meta title={<IntlMessages id="common.logout" />} />
      </List.Item>
    </List>
  );

  return (
    <Fragment>
      <div
        className={clsx("cr-user-info", {
          light: themeMode === "light",
        })}
      >
        <Dropdown
          dropdownRender={() => menu}
          trigger={["click"]}
          placement="bottomRight"
          overlayStyle={{
            zIndex: 1052,
            minWidth: 150,
          }}
        >
          <a className="cr-user-info-inner ant-dropdown-link">
            <Avatar size={36} className="cr-user-initials-avatar">
              {initials}
            </Avatar>
            <div className="cr-user-info-name-role">
              <span>
                {myProfile?.firstName} {myProfile?.lastName}
              </span>
              {userRole && (
                <span>
                  <IntlMessages id={userRole?.label} />
                </span>
              )}
            </div>
          </a>
        </Dropdown>
      </div>
    </Fragment>
  );
};

export default UserInfo;
